'use strict';

var $ = require('jquery');

$(function() {
	var openOverlay = $('.company-admin .open-overlay'),
		overlays = $('.company-admin .overlay');


	/* Handles opening overlays */
	openOverlay.each(function() {
		var overlay = $(this).data('overlay'),
			button = $(this);
		$(this).click(function() {
			overlays.each(function() {
				if ($(this).hasClass(overlay)) {
					$(this).removeClass('hidden');
					
					/* Overlay specific things */
					if (button.hasClass('delete')) {
						$(this).find('.username').text(button.data('login'));
						$(this).find('#delete-user-id').val(button.data('id'));
					}

					if (button.hasClass('edit')) {
						$(this).find('.username').text(button.data('login'));
						$(this).find('#edit-user-login').val(button.data('login'));
						$(this).find('#edit-user-email').val(button.data('email'));
						$(this).find('#edit-user-phone').val(button.data('phone'));
						$(this).find('#edit-user-firstname').val(button.data('firstname'));
						$(this).find('#edit-user-lastname').val(button.data('lastname'));
						$(this).find('#edit-user-additional-information').val(button.data('additional'));
						$(this).find('#edit-user-id').val(button.data('id'));
					}
				}
			});
		});

	});

	/* Handles closing overlays */
	overlays.each(function() {
		var that = this;
		$(this).find('.close').click(function() {
			$(that).addClass('hidden');
		});
	});

	/* User import overlay close button, if no changes were found */
	var userImportOverlay = $('.user-list-import');
	if (userImportOverlay.length) {
		var okButton = userImportOverlay.find('.confirm');
		okButton.click(function() {
			// Close overlay
			userImportOverlay.addClass('hidden');
		});
	}

	/* Show file name, when uploading .csv */
});
